"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageCollection = void 0;
var react_1 = __importStar(require("react"));
var inversify_react_1 = require("inversify-react");
var debounce_1 = __importDefault(require("lodash/debounce"));
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var PageCollectionItem_1 = require("./PageCollectionItem");
var PageFilterEditModal_1 = require("Reports/Modals/PageFilter/PageFilterEditModal");
var c = (0, BemBuilder_1.default)("page-collection");
var PageCollection = function (_a) {
    var collection = _a.collection, actions = _a.actions;
    var deleter = actions.deleter, updater = actions.updater;
    var modalService = (0, inversify_react_1.useInjection)("modal");
    var userDataStore = (0, inversify_react_1.useInjection)("rootDataStore").userDataStore;
    var _b = __read((0, react_1.useState)(false), 2), expanded = _b[0], setExpanded = _b[1];
    var _c = __read((0, react_1.useState)(collection.name), 2), collectionName = _c[0], setCollectionName = _c[1];
    var collectionCardRef = (0, react_1.useRef)();
    var confirmDelete = function () { return __awaiter(void 0, void 0, void 0, function () {
        var confirmed;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, modalService.showDeleteModal({
                        title: "Delete Saved Filter?",
                        explainer: "This Saved Filter will no longer be available for reporting.",
                        isEscapable: true,
                    })];
                case 1:
                    confirmed = _a.sent();
                    if (confirmed) {
                        deleter(collection._id);
                    }
                    return [2];
            }
        });
    }); };
    var asyncNameUpdate = (0, react_1.useCallback)((0, debounce_1.default)(function (newName) { return updater(__assign(__assign({}, collection), { name: newName })); }, 1000), [collection]);
    var handleNameChange = function (newName) {
        asyncNameUpdate(newName);
        setCollectionName(newName);
    };
    var handleDefaultChange = function () {
        updater(__assign(__assign({}, collection), { isDefault: !collection.isDefault }));
    };
    (0, react_1.useEffect)(function () {
        var _a;
        if ((collectionCardRef === null || collectionCardRef === void 0 ? void 0 : collectionCardRef.current) && expanded)
            (_a = collectionCardRef === null || collectionCardRef === void 0 ? void 0 : collectionCardRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView();
    }, [expanded]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        collection.isDefault && (react_1.default.createElement("div", { className: c("default-label") },
            react_1.default.createElement(kaleidoscope_1.Text, { size: "xs", strong: true }, "Default filter"))),
        react_1.default.createElement("div", { className: "".concat(c(""), " ").concat(expanded ? "expanded" : "", " "), ref: collectionCardRef },
            react_1.default.createElement(kaleidoscope_1.Card, { className: c("card") },
                react_1.default.createElement("div", { className: c("title"), "aria-expanded": expanded },
                    react_1.default.createElement("div", { className: c("name-input") },
                        react_1.default.createElement(kaleidoscope_1.TextInput, { label: "Filter name", labelHidden: true, variant: kaleidoscope_1.TextInputVariant.Borderless, size: kaleidoscope_1.TextInputSize.Large, value: collectionName, onChange: handleNameChange, endElement: react_1.default.createElement(icons_1.Edit, { size: icons_1.IconSize.Small }), elementSize: collectionName.length }),
                        react_1.default.createElement(kaleidoscope_1.Text, { size: "xs", align: "left", className: c("name-label") },
                            "Created by",
                            collection.createdByQwilr ? " Qwilr" : " ".concat(userDataStore.firstName, " ").concat(userDataStore.lastName))),
                    react_1.default.createElement("div", { className: c("card-actions") },
                        react_1.default.createElement(kaleidoscope_1.IconButton, { icon: expanded ? react_1.default.createElement(icons_1.ChevronUp, null) : react_1.default.createElement(icons_1.ChevronDown, null), onClick: function () { return setExpanded(!expanded); } }),
                        !collection.createdByQwilr && (react_1.default.createElement(kaleidoscope_1.OptionMenu, { className: c("card-actions__dropdown"), button: react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.OptionsVertical, null) }) },
                            react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { destructive: true, onClick: confirmDelete }, "Delete"))))),
                react_1.default.createElement(kaleidoscope_1.Expandable, { expanded: expanded }, function (_a) {
                    var expandableElementRef = _a.expandableElementRef;
                    return (react_1.default.createElement("div", { ref: expandableElementRef },
                        react_1.default.createElement(PageCollectionItem_1.PageCollectionItem, { title: "Filters", subtitle: "Collection of pages created from selected templates, tags and selected content type (eg. quote blocks)", modal: function (close) { return (react_1.default.createElement(PageFilterEditModal_1.PageFilterEditModal, { existingFilters: collection.pageFilter, onApply: function (newPageFilter) { return updater(__assign(__assign({}, collection), { pageFilter: newPageFilter })); }, closeModal: close })); } }),
                        react_1.default.createElement(kaleidoscope_1.Checkbox, { item: {
                                id: "default-collection",
                                value: "default Saved Filter",
                                label: "Set as default Saved Filter",
                            }, isSelected: collection.isDefault, onChange: handleDefaultChange })));
                })))));
};
exports.PageCollection = PageCollection;
